var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simpleSalesScreen',{attrs:{"outsideTypeSale":'Pedido'}})
}
var staticRenderFns = []

export { render, staticRenderFns }